const ReviewList = [
  {
    cards: [
      {
        details:
          '"Easy tracking of billable hours across various projects. Makes time tracking for different tasks simple."',
        author: "- Paul H., Business Owner",
      },
      {
        details:
          '"Ease of use, simplicity, streamlined, it really helped me get my hour tracking in order. No negatives for the purpose and scope for which I am using the software."',
        author: "‍- Arieh F., CFO  ‍",
      },
      {
        details:
          '"Easy to use for my team members who are remote but hourly. My House provides a simple and easy way to record, track and manage activity."',
        author: "‍‍- Thomas S., Head of Customer Success",
      },
    ],
  },
  {
    cards: [
      {
        details:
          '"My Hours is great for keeping track of time spent on different projects. It makes completing my mandatory timesheets at the end of the week WAY FASTER."',
        author: "‍- Michael B., Manager",
      },
      {
        details:
          '"The software is very easy to set up, and you can start using it right away to track your time, assigning different hourly rates for different types of work."',
        author: "‍‍‍- Naomi S., Marketing Manager‍ ‍",
      },
      {
        details:
          '"I really love this time tracking software. It keeps track of all my hours and is really easy to use. I would definitely recommend this software. There is nothing that I don\'t like about this software."',
        author: "‍‍‍- Christina C., Paralegal",
      },
    ],
  },
  {
    cards: [
      {
        details:
          '"I\'ve enjoyed using My Hours, and I use it every day. Great tool for tracking my time!"',
        author: "‍‍- Cody H., Engineer",
      },
      {
        details:
          '"Simple to use, perfect for the price, genuinely the best hour tracker I\'ve used yet."',
        author: "‍‍‍‍- Leah M., Engineer",
      },
      {
        details:
          '"This is the easiest-to-use software that I\'ve found in terms of tracking hours and minutes for multiple projects."',
        author: "‍‍‍‍- Michelle W., Virtual Assistant",
      },
      {
        details:
          '"I love that I can track my hours and use it to generate meaningful reports to measure time spent. It\'s intuitive, easy-to-use, and highly customizable."',
        author: "‍‍‍‍‍- Kristen B., Bussines Owner",
      },
    ],
  },
];

export { ReviewList };
